export const processedSessionResultsData = data => {
  if (!data || !data.catalogs) {
    return [];
  }

  const { grandTotals, catalogHeaders, memberSums, catalogs } = data || {};

  const groupedData = data.catalogs.reduce((result, item) => {
    const { memberID, ...otherItemProps } = item;

    if (!result[memberID]) {
      result[memberID] = {
        items: [],
        memberSums: {}
      };
    }

    const memberData = result[memberID];

    if (!memberData.firstName && !memberData.lastName) {
      Object.assign(memberData, { ...otherItemProps, memberID, bidderAddress: { ...item.bidderAddress } });
    } else {
      Object.assign(item, {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        bidderAddress: { city: '', countryID: '', postCode: '', stateID: '' }
      });
    }

    memberData.items.push(item);

    if (data.memberSums && data.memberSums[item.memberRef]) {
      memberData.memberSums = data.memberSums[item.memberRef];
    }

    return result;
  }, {});

  const dataArray = Object.values(groupedData);
  dataArray.sort((a, b) => a.lastName.localeCompare(b.lastName, undefined, { sensitivity: 'base' }));

  return { memberSums, catalogs, grandTotals, catalogHeaders, groupedData: dataArray };
};
